module.exports = __webpack_public_path__ + "img/DSC_1090.6099882b.jpg";